import { useContext, useState } from 'react'
import { deactivateChannel } from 'shared/api'
import { useChannelWithNormalGifFetch } from 'shared/api/channels'
import ChannelPageContext from 'shared/contexts/channel-page'
import UserContext from 'shared/contexts/user'
import useAsyncEffect from 'shared/hooks/use-async-effect'
import { getSearchTitle } from 'shared/util/search'
import styled from 'styled-components'
import DeactivateUser from './components/deactivate'
import { Description } from './components/description'
import HeaderCollectionButtons from './components/header-collection-buttons'
import { Title } from './components/title'

const HeaderSC = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: top;
`

const Header = ({ overrideTitle }: { overrideTitle?: string }) => {
    const [title, setTitle] = useState('')
    const [confirmDeactivate, setConfirmDeactivate] = useState(false)
    const { channel, channelType, isTagView, searchQuery } = useContext(ChannelPageContext)
    const { user: staffUser } = useContext(UserContext)
    const { display_name, url, user, id, description, is_live, short_display_name, parent, content_type } = channel
    const isChild = !!parent
    let fetchOptions
    if (channelType === 'tagged_channel' || channelType === 'search_channel') {
        fetchOptions = { term: searchQuery, isFeaturedTag: isTagView }
    }
    const fetchGifs = useChannelWithNormalGifFetch(id, fetchOptions)
    useAsyncEffect(async () => {
        if (searchQuery) {
            const {
                pagination: { total_count },
            } = await fetchGifs(0)
            setTitle(getSearchTitle(total_count, content_type, isTagView) || '')
        } else {
            setTitle(display_name || user.username)
        }
    }, [channel.id, searchQuery, display_name, user?.username])

    const ancestors = channel.ancestors || []

    const handleDeactivate = async (
        userToDeactivate: string,
        reason: string,
        shouldEmailUser: boolean,
        additionalInfo: string,
        reporter: string
    ) => {
        try {
            await deactivateChannel(userToDeactivate, reason, additionalInfo, shouldEmailUser, reporter)
            console.log('API successfully deactivated channel', userToDeactivate)
        } catch (error) {
            console.error('Error deactivating user:', error)
        }
        setConfirmDeactivate(false)
    }

    if (!title) {
        return null
    }
    return (
        <div>
            <HeaderSC>
                <Title
                    user={user}
                    breadcrumbs={ancestors}
                    displayName={display_name}
                    shortDisplayName={short_display_name}
                    title={overrideTitle || title}
                    searchQuery={searchQuery}
                    isTagView={isTagView}
                    url={url}
                    isChild={isChild}
                    isLive={is_live}
                />
                {confirmDeactivate && (
                    <DeactivateUser
                        userToDeactivate={channel.user.username}
                        message="Are you sure you want to deactivate this user?"
                        onConfirm={() => setConfirmDeactivate(false)}
                        onCancel={() => setConfirmDeactivate(false)}
                        onDeactivate={handleDeactivate}
                    />
                )}

                {staffUser.isStaff && (
                    <button
                        onClick={() => setConfirmDeactivate(true)}
                        style={{ marginRight: '12px', height: '37.25px' }}
                    >
                        Deactivate User
                    </button>
                )}
                <HeaderCollectionButtons />
            </HeaderSC>
            {isChild ? <Description description={description} /> : null}
        </div>
    )
}

export default Header
